<template>
  <div
    v-if="modes.length === 1"
  >
  <strong
    :style="myTitleStyle"
  >
    {{ mode.name }}
  </strong>
  </div>
  <!-- <p
    v-else
    :style="myTitleStyle"
    @click="openDialog">
    <strong>{{ mode.name }}</strong>
    <span :style="routeColor">{{ $t('change') }}</span>
  </p> -->
  <div
    v-else
  >
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset-y
  >
    <strong
      :style="myTitleStyle"
      slot="activator"
    >
      {{ mode.name }}
      <v-icon
        large
        :color="theme.dining_title_color"
        :style="iconStyle"
      >arrow_drop_down</v-icon>
    </strong>
    <v-card width="300px">
      <v-list>
        <v-list-tile>
          <v-list-tile-title>
          <h3 :style="myLocationStyle">{{ $t('mode') }}</h3>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-list>
        <v-list-tile
          v-for="m in modes"
          :key="m.index"
          @click="changeMode(m)"
        >
          <v-list-tile-title>
            <h3>{{ m.name }}</h3>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    menu: false
  }),
  computed: {
    ...mapGetters('config', [
      'theme', 'modes', 'mode', 'config'
    ]),
    ...mapGetters('cart', [
      'cartQty', 'pickupDate', 'pickupTime', 'dates', 'times'
    ]),
    pickupInfo () {
      const date = this.dates.find(d => d.date === this.pickupDate)
      const time = this.times.find(t => t.time === this.pickupTime)
      if (!date || !time) {
        return this.$t('select_time')
      } else {
        if (date.weekDay === 'Today') {
          return this.$t('today_at') + this.pickupTime
        }
        return date.day + ' ' + date.month + ' ' + this.pickupTime
      }
    },
    myTitleStyle () {
      return {
        fontSize: this.config.diningmodetitle_fontsize,
        borderBottom: `1px dashed ${this.theme.dining_title_color}`,
        display: 'inline-block',
        lineHeight: '40px',
        marginBottom: '20px',
        color: this.theme.dining_title_color
      }
    },
    myLocationStyle () {
      return {
        color: this.theme.dining_title_color
      }
    },
    iconStyle () {
      return {
        fontSize: this.config.diningmodetitle_fontsize,
        marginRight: '-6px'
      }
    },
    routeColor () {
      return {
        color: this.theme.app_chg_color
      }
    },
    myModeStyle () {
      return {
        fontSize: '14px',
        color: this.theme.toolbar_color,
        backgroundColor: this.theme.toolbar_bg_color,
        display: 'inline-block',
        marginLeft: '4px',
        padding: '8px 16px',
        borderRadius: '3px',
        cursor: 'pointer',
        width: '150px',
        textAlign: 'center',
        verticalAlign: 'top'
      }
    },
  },
  methods: {
    changeMode (mode) {
      this.menu = false
      if (parseInt(mode.index) !== parseInt(this.mode.index)) {
        if (this.cartQty > 0) {
          const text = 'If you change dining mode, your selections in basket will be cleared. Are you sure?'
          this.$store.dispatch('responseMessage', {
            type: 'error',
            title: 'Start New Order',
            text: text,
            modal: true,
            buttons: [
              { text: 'Cancel' },
              { text: 'Ok', action: 'changeDiningMode', param: mode, path: 'welcome' }
            ]
          })
        } else {
          this.$store.dispatch('changeDiningMode', mode)
          this.$router.push({ name: 'welcome' })
        }
      }
    },
    // async openDialog () {
    //   if (this.cartQty > 0) {
    //     const text = 'If you change dining mode, your selections in basket will be cleared. Are you sure?'
    //     this.$store.dispatch('responseMessage', {
    //       type: 'error',
    //       title: 'Start New Order ?',
    //       text: text,
    //       modal: true,
    //       buttons: [
    //         { text: 'Cancel' },
    //         { text: 'Ok', action: 'resetModeSelected', path: 'welcome' }
    //       ]
    //     })
    //   } else {
    //     await this.$store.dispatch('config/resetModeSelected')
    //   }
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DiningModeTitle.vue